export var DROPDOWN = 'dropdown';
export var TABS = 'tabs';
export var LABEL = 'label';
export var TOOLTIP = 'tooltip';
export var SPAN = 'span';
export var GROUPBOX = 'groupbox';
export var TABLE = 'table';
export var TOOL_TIP_BUTTON = 'tool_tip_button';
export var INDICATOR_BUTTON = 'indicator_button';
export var LABEL_CONTAINER = 'label_container';
export var BUTTON = 'button';
export var GRID = 'grid';
export var DIV = 'div';
export var LABEL_VALUE = 'label_value';
export var STATE_VALUE = 'state_value';
//# sourceMappingURL=componentTypes.js.map